import Lottie from 'lottie-react'
import { DARK_TREATMENTS, type DarkTreatment } from './darkTreatment'
import teamworkAnimation from '../../assets/animations/teamwork.json'

interface PartnershipIconProps {
  className?: string
  size?: number
  /**
   * How the icon handles a dark surface. Defaults to 'none', NOT 'silhouette' like most
   * of this directory: before the prop existed this component rendered Lottie with no
   * filter wrapper at all, so 'none' is what preserves its behaviour. Setting it to
   * 'silhouette' for consistency would change how it looks on every page that uses it.
   */
  darkTreatment?: DarkTreatment
}

const PartnershipIcon = ({ className = "w-12 h-12", size, darkTreatment = 'none' }: PartnershipIconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
      <div className={`${DARK_TREATMENTS[darkTreatment]} w-full h-full`}>
        <Lottie
          animationData={teamworkAnimation}
          loop={true}
          autoplay={true}
          style={{ width: size || '100%', height: size || '100%' }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet'
          }}
        />
      </div>
    </div>
  )
}

export default PartnershipIcon